<template>
  <app-popup
    :active.sync="isActive"
    title="Квартиры, сдавшие меньшие показания"
    width="100%"
    class="employee-big-values-popup"
  >
    <div class="employee-not-hand-over-values-popup__header">
      <div class="ml-auto">
        <div class="link-icon employee-not-hand-over-values-popup__export" @click="exportTable">
          <app-icon name="DownloadFile" />
        </div>
      </div>
    </div>
    <div class="employee-not-hand-over-values-popup__content">
      <grid-infinite-scroll
        ref="table"
        :columns="columns"
        :getData="updateData"
        :maxConcurrentDatasourceRequests="4"
        :rowHeight="50"
        :pageSize="20"
        key="valueTable"
        :filterable="false"
        noRowsText="Квартир нет"
      />
    </div>
  </app-popup>
</template>

<script>
import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";

export default {
  name:     "LowerValuesPopup",
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    columns() {
      return [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          suppressSizeToFit:     false,
          pinned:                this.windowWidth < 500 ? "none" : "left",
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:        'Помещение',
          field:             'number',
          suppressSizeToFit: false,
          minWidth:          120,
          pinned:            this.windowWidth < 500 ? "none" : "left",
        },
        {
          headerName: 'Собственник',
          field:      'user_full_name',
          filter:     false,
          editable:   false,
          minWidth:   120,
        },
        {
          headerName: 'Телефон',
          field:      'user_phone',
          filter:     false,
          editable:   false,
          minWidth:   120,
        },
        {
          headerName:        'Месяц показания',
          field:             'date_value',
          suppressSizeToFit: false,
          minWidth:          120,
          valueGetter:       ( { data } ) => {
            return data.date_value ? this.$options.filters.moment(this.$parseDateFromString(data.date_value), 'MMMM YYYY') : '-';
          },
        },
      ];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    open() {
      this.isActive = true;
    },
    exportTable() {
      this.$vs.loading();
      this.$refs.table.exportRows('Квартиры, сдавшие меньшие показания');
    },
    updateData( page, filters, orderBy ) {
      let params = {
        orderby:      orderBy,
        filters:      filters,
        page:         page,
        buildings_id: this.selectedHouseId,
      };
      return this.$http.get('device_with_values_less_than_previous', { params }).then(( { data } ) => {
        this.$vs.loading.close();
        return {
          response: data.data,
          data:     data.data,
          total:    data.total,
        };
      });
    },
  },
};
</script>

<style lang="scss">
.employee-big-values-popup {
  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal__body {
    height: 100%;
  }

  .modal__content {
    display: flex;
    flex-direction: column;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    flex-shrink: 0;
  }

  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__main-action {
    display: flex;
    align-items: flex-end;
    margin: -8px;

    &-col {
      padding: 8px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}
</style>
